import GlobalRequest from '../../../../../api/global-request';
import AppError from '../../../../../helpers/app-errors';

const DATASOURCE_URL = 'v2/datasource';

class DataSourceService {
    // ===> Get all existing datasources
    async getAllDataSources(params) {
        try {
            return await GlobalRequest.getRequest(DATASOURCE_URL, {
                params,
            });
        } catch (error) {
            throw new AppError(error.status, 'Failed to fetch all datasources');
        }
    }

    // ====> Get datasource details by id
    async getDataSourceDetails(id, companyId) {
        try {
            return await GlobalRequest.getRequest(`${DATASOURCE_URL}/${id}`, {
                params: {
                    company_id: companyId,
                },
            });
        } catch (error) {
            throw new AppError(error.status, 'Failed to fetch datasource details');
        }
    }

    // ===> Add new datasource
    async addDataSource(bodyParams) {
        try {
            return await GlobalRequest.postRequest(DATASOURCE_URL, bodyParams);
        } catch (error) {
            throw new AppError(error.status, 'Failed to add new datasource');
        }
    }

    // ===> Update existing datasource
    async updateDataSource(id, bodyParams) {
        //console.trace();

        try {
            return await GlobalRequest.patchRequest(`${DATASOURCE_URL}/${id}`, bodyParams);
        } catch (error) {
            throw new AppError(error.status, `Failed to update datasource ${id}`);
        }
    }

    // ===> Delete existing datasource
    async deleteDataSource(id, companyId) {
        try {
            return await GlobalRequest.deleteRequest(`${DATASOURCE_URL}/${id}`, {
                params: {
                    company_id: companyId,
                },
            });
        } catch (error) {
            throw new AppError(error.status, `Failed to delete datasource ${id}`);
        }
    }
}
export default new DataSourceService();
